"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planButtonTestConfig = exports.planButtonDefaultConfig = exports.PlanButtonConfig = void 0;
const zod_1 = require("zod");
exports.PlanButtonConfig = zod_1.z.enum(["off", "on", "control", "test"]);
const PlanButtonTestConfig = zod_1.z.object({
    start_button_text: zod_1.z.string(),
    start_button_sub_text: zod_1.z.string(),
    core_button_text: zod_1.z.string(),
    core_button_sub_text: zod_1.z.string(),
    pro_button_text: zod_1.z.string(),
    pro_button_sub_text: zod_1.z.string(),
});
exports.planButtonDefaultConfig = {
    start_button_text: "Choose Starter",
    start_button_sub_text: "Free for 14 days! Cancel anytime",
    core_button_text: "Choose Core",
    core_button_sub_text: "Free for 14 days! Cancel anytime",
    pro_button_text: "Choose Pro",
    pro_button_sub_text: "Free for 14 days! Cancel anytime",
};
exports.planButtonTestConfig = {
    start_button_sub_text: "Cancel anytime",
    start_button_text: "Try Starter · 14 Days Free",
    core_button_text: "Try Core · 14 Days Free",
    core_button_sub_text: "Cancel anytime",
    pro_button_sub_text: "Cancel anytime",
    pro_button_text: "Try Pro · 14 Days Free",
};
//# sourceMappingURL=plan.js.map